{
  "Thank you for filling in the form.": "Thank you for filling in the form.",
  "There was an error in your submission, please try again in a few seconds. If the issue persists, please contact us.": "There was an error in your submission, please try again in a few seconds. If the issue persists, please contact us."
}
